import { mapActions } from 'vuex';
import Events from '_utils/events';
import EquipmentService from '_services/rest/modules/equipment';
import { _DELETE_EQUIPMENT_ } from './EquipmentModel';

export default {
  name: 'equipment-delete',
  data() {
    return {
      selectedEquipment: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      EquipmentService.deleteEquipment(this.selectedEquipment)
        .then(() => {
          this.close();
          this.$router.push('/admin/equipamentos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Equipamento deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_DELETE_EQUIPMENT_, equipment => {
      this.selectedEquipment = equipment.id;
    });
  },
};
